<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.serial_num">
  <app-popup-header title="{{localService.languageContent.serial_num.header}}"></app-popup-header>
  <div class="modal-body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <div *ngIf="!isIntegerQty">
      {{localService.languageContent.serial_num.need_valid_integer}}
    </div>
    <div *ngIf="isIntegerQty">
      <div class="row">
        <div class="col-12" style="text-align:right;">
          <span>{{localService.languageContent.serial_num.ser_req_qty}}</span>
          <span class="en">&nbsp;:&nbsp;{{qty}}</span>
        </div>
      </div>
      <div class="row" *ngIf="!isViewMode && selectedSerialNumbers.length < qty">
        <div class="col-12" style="text-align:center;">
          <button type="button" class="btn btn-primary" (click)="onApplyDummy()">
            <span>&nbsp;({{qty - selectedSerialNumbers.length}})&nbsp;</span>
            {{localService.languageContent.serial_num.create_dummy}}
          </button>
        </div>
      </div>
      <div *ngIf="!isViewMode && serialNumbers && selectedSerialNumbers.length < qty">
        <div class="row">
          <div class="col-12">
            <input autocomplete="off" type="text" id="{{elementIds.manual_ser_num}}" (input)="onSerialEnter($event)"
              [ngClass]="txtSerialNumber ? 'en' : ''" [(ngModel)]="txtSerialNumber" 
              placeholder="*{{localService.languageContent.serial_num.manual_ser_num}}"
              title="*{{localService.languageContent.serial_num.manual_ser_num}}" (keydown.enter)="onAddSerialNumber(true)" style="width: calc(100% - 35px);top: 5px;" />
            <button class="button_icon button_icon_color" (click)="onAddSerialNumber(true)">add_circle_outline</button>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <ngx-select style="width: calc(100% - 40px);float:left;" [(ngModel)]="selectedSerialNumber"
              [items]="serialNumbers" [optionValueField]="'key'" [optionTextField]="'v1'"
              (open)="showHideDummyHeight(true)" (close)="showHideDummyHeight(false)" (select)="onAddSerialNumber()"
              placeholder="{{localService.languageContent.serial_num.select_serial_num}}"
              title="{{localService.languageContent.serial_num.select_serial_num}}">
            </ngx-select>
            <i class="material-icons" style="float:right;margin-top:10px;"
              (click)="onLoadSerialNumbers()">replay_circle_filled</i>
          </div>
        </div>
      </div>
      <div class="row en" *ngFor="let item of selectedSerialNumbers; index as i">
        <div class="col-12">
          <i class="material-icons delete_icon action_icon" (click)="onRemove(item.key)" *ngIf="!isViewMode">cancel</i>
          <span>{{i+1}}&nbsp;-&nbsp;</span>
          <span *ngIf="item.key == '-'"
            class="{{localService.selectedLanguageCode}}">{{localService.languageContent.serial_num.create_dummy}}</span>
          <span *ngIf="item.key != '-'" [ngClass]="item.v3 == '1' ? 'used_serial_num' : ''">{{item.v1}}</span>
        </div>
      </div>
      <div *ngIf="isShowDummyHeight" [ngStyle]="{'height' : localService.getHeightOfOpenedControl(2) + 'px'}">
        &nbsp;
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" *ngIf="!isViewMode" [disabled]="!isIntegerQty || (selectedSerialNumbers.length != qty && txtSerialNumber)"
      (click)="onPopupSave()">{{localService.languageContent.common.save}}</button>
  </div>
</div>